export default "__VITE_ASSET__07fd1f90__"